import { call, put, takeLatest } from "redux-saga/effects"
import { SEARCH_DOCUMENT_LIST} from "./actionTypes"
import { SEARCH_FORM_LIST, RECENT } from "./actionTypes";
import {
    apiErrorSearchDocument,
    searchDocumentSuccess,
    apiErrorSearchForm,
    searchFormSuccess,
    apiErrorRecent,
    recentSuccess
} from "./actions"
import { toast } from "react-toastify";

import {
    getSearchDocumentAPI,
    getSearchFormAPIV2
} from "../../helpers/call_api"


function* getSearchDocument({ payload: { search, navigate } }) {
  try {

    const response = yield call(getSearchDocumentAPI, search.page, search.pageSize, search.period , search.data)
    /*try {
      //toast('Result Search: ' + response.data.length + " documents",'success');
    } catch (error) {
      toast('Result Search Error ','success');
    }
      */
    yield put(searchDocumentSuccess(response))
  } catch (error) {
      if(error?.response?.status){
          if(error.response.status===401){
              navigate('/login');
          }
          if(error.response.status===400){
              console.error('SearchDocuments API 400 Error - Bad Request:', {
                  message: error.response.data?.message || 'Invalid search parameters',
                  data: error.response.data,
                  searchParams: search
              });
              toast('Invalid search parameters. Please check your filters and try again.', 'error');
          }
      }
     yield put(apiErrorSearchDocument(error))
  }
}

function* getSearchForm({ payload: { search, navigate } }) {
  try {
        const response = yield call(
          getSearchFormAPIV2,
          search.page,
          search.pageSize,
          search.data,
          search.sortBy,
          search.sortOrder
        )
        /*try {
          //toast('Result Search: ' + response.data.length + " documents",'success');
        } catch (error) {
          toast('Result Search Error ','success');
        }
          */
        yield put(searchFormSuccess(response))
    } catch (error) {
        if(error?.response?.status){
            if(error.response.status===401){
                navigate('/login');
            }
            if(error.response.status===400){
                console.error('SearchForm API 400 Error - Bad Request:', {
                    message: error.response.data?.message || 'Invalid search parameters',
                    data: error.response.data,
                    searchParams: search
                });
                toast('Invalid search parameters. Please check your filters and try again.', 'error');
            }
        }
        yield put(apiErrorSearchForm(error))
    }
}

function* getRecent({ payload: { search, navigate } }) {
  try {

    const response = yield call(getSearchDocumentAPI, search.page, search.pageSize, search.period , search.data)
    /*try {
      //toast('Result Search: ' + response.data.length + " documents",'success');
    } catch (error) {
      toast('Result Search Error ','success');
    }
      */
    yield put(recentSuccess(response))
  } catch (error) {
      if(error?.response?.status){
          if(error.response.status===401){
              navigate('/login');
          }
          if(error.response.status===400){
              console.error('Recent Documents API 400 Error - Bad Request:', {
                  message: error.response.data?.message || 'Invalid search parameters',
                  data: error.response.data,
                  searchParams: search
              });
              toast('Invalid search parameters. Please check your filters and try again.', 'error');
          }
      }
      yield put(apiErrorRecent(error))
  }
}



function* authSaga() {
  // Latest wins: ignore stale responses when user types/clears quickly
  yield takeLatest(SEARCH_DOCUMENT_LIST, getSearchDocument)
  yield takeLatest(SEARCH_FORM_LIST, getSearchForm)
  yield takeLatest(RECENT, getRecent)
}

export default authSaga
